import { post, get, put } from "./Tools";

const getConceptosVarable = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_variable/get/conceptos-variable`);
  return response;
}

const updateConceptoVariable = async (id, activo) => {
  const response = await put(`${process.env.REACT_APP_SERVER}concepto`, {
    id,
    activo
  });
  return response;
}

const getVariable = async (fecha) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_variable/${fecha}`);
  return response;
}

const actualizarVariable = async (fecha) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_variable/actualizar/${fecha}`, {});
  return response;
}

export { getConceptosVarable, updateConceptoVariable, getVariable, actualizarVariable };